import { createAppToasts, type ShowToastOptions } from "@loot-os/design-system/core/useToast";

/** The store's one toast outlet, mounted by App; `showToast` works from anywhere, React or not. */
export const storeToasts = createAppToasts();

/** Shows a toast: a save, a refusal, a notification that just arrived. */
export function showToast(options: ShowToastOptions): void {
  storeToasts.show(options);
}
